export default {
    UPDATE: 'update',
    SPLIT: 'split',
    MOVE_TRIPS: 'move-trips',
};
